// extracted by mini-css-extract-plugin
module.exports = {"flag-btn":"style_flag-btn__2osAe","student-info-label":"style_student-info-label__RYKKT"};